import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareKnowledgeClassicRoute: InvariantJiraRoute = {
	name: 'software-knowledge-classic',
	path: '/jira/software/c/projects/:projectKey/knowledge',
	exact: true,
};
